module.exports = __webpack_public_path__ + "img/AI_C.5643481c.png";